var map = {
	"./1.png": "4cb7",
	"./10.png": "7855",
	"./2.png": "f2c4",
	"./3.png": "5835",
	"./4.png": "1d97",
	"./5.png": "d8c1",
	"./6.png": "971e",
	"./7.png": "aedd",
	"./8.png": "b099",
	"./9.png": "f4a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7422";